/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loud_Fair_Yak_DripInputs */

const en_loud_fair_yak_drip = /** @type {(inputs: Loud_Fair_Yak_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login activated`)
};

const de_loud_fair_yak_drip = /** @type {(inputs: Loud_Fair_Yak_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login aktiviert`)
};

/**
* | output |
* | --- |
* | "Login activated" |
*
* @param {Loud_Fair_Yak_DripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const loud_fair_yak_drip = /** @type {((inputs?: Loud_Fair_Yak_DripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loud_Fair_Yak_DripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loud_fair_yak_drip(inputs)
	return de_loud_fair_yak_drip(inputs)
});